import { Link } from 'react-router-dom';

const articles = [
  {
    path: '/acbuy-spreadsheet-explained',
    title: 'ACBuy Spreadsheet Explained – The Smart Shopping System',
    excerpt: 'A detailed breakdown of how the acbuy spreadsheet organizes product data, saves time, and transforms the online shopping experience for casual buyers and power shoppers alike.',
    tag: "Beginner's Guide",
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20notebook%20and%20minimal%20accessories%20on%20warm%20wood%20surface%2C%20soft%20natural%20light%2C%20editorial%20workspace%20photography%2C%20calm%20productive%20aesthetic%2C%20cream%20and%20beige%20tones&width=600&height=400&seq=blog-explained-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-deals',
    title: 'How ACBuy Spreadsheet Helps You Find Better Deals Instantly',
    excerpt: 'Learn the exact methods savvy shoppers use with the acbuy spreadsheet to spot price drops, compare options, and never overpay for products again.',
    tag: 'Money-Saving Tips',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20price%20tag%20and%20shopping%20bag%20concept%20on%20minimal%20cream%20surface%2C%20soft%20dramatic%20lighting%2C%20editorial%20product%20photography%2C%20warm%20sophisticated%20aesthetic%2C%20subtle%20gold%20accents&width=600&height=400&seq=blog-deals-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-review-2026',
    title: 'ACBuy Spreadsheet Review 2026: Is It Worth Using?',
    excerpt: 'An honest, in-depth review of the acbuy spreadsheet system covering features, usability, and whether it deserves a place in your shopping toolkit.',
    tag: 'In-Depth Review',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20product%20review%20setup%20with%20notebook%20pen%20and%20coffee%20on%20light%20marble%20surface%2C%20soft%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20tones%2C%20clean%20thoughtful%20composition&width=600&height=400&seq=blog-review-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-vs-amazon',
    title: 'ACBuy Spreadsheet vs Amazon – Which Is Better?',
    excerpt: 'Side-by-side comparison of the acbuy spreadsheet and Amazon for finding, comparing, and tracking products. See which delivers better results.',
    tag: 'Comparison',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20two%20contrasting%20shopping%20concepts%20on%20minimal%20background%2C%20soft%20editorial%20lighting%2C%20clean%20graphic%20aesthetic%2C%20warm%20neutral%20palette%2C%20modern%20comparison%20concept&width=600&height=400&seq=blog-vs-amazon-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-trend-2026',
    title: 'Why Everyone Is Switching to ACBuy Spreadsheet in 2026',
    excerpt: 'Explore the cultural and practical reasons behind the growing adoption of the acbuy spreadsheet as the go-to product intelligence tool for modern shoppers.',
    tag: 'Trends & Insights',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=Growing%20community%20of%20stylish%20people%20browsing%20on%20devices%20in%20bright%20modern%20cafe%2C%20natural%20daylight%2C%20editorial%20lifestyle%20photography%2C%20warm%20contemporary%20aesthetic%2C%20diverse%20group%20casual%20interaction&width=600&height=400&seq=blog-trend-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-beginners',
    title: 'ACBuy Spreadsheet Guide for Beginners: Step-by-Step',
    excerpt: 'A complete beginner-friendly walkthrough of the acbuy spreadsheet system. Navigate categories, compare products, and track trends from day one.',
    tag: 'Step-by-Step Guide',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=Open%20guidebook%20with%20clean%20pages%20next%20to%20minimal%20desk%20plant%20on%20light%20wood%2C%20soft%20morning%20sunlight%2C%20editorial%20learning%20concept%20photography%2C%20warm%20inviting%20aesthetic%2C%20calm%20focused%20atmosphere&width=600&height=400&seq=blog-beginners-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-safe',
    title: 'Is ACBuy Spreadsheet Safe? Full Honest Breakdown',
    excerpt: 'A transparent examination of safety, privacy, and trust factors surrounding the acbuy spreadsheet. Everything new users need to know before getting started.',
    tag: 'Safety & Trust',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=Shield%20icon%20and%20checkmark%20concept%20with%20soft%20warm%20background%2C%20minimal%20trust%20and%20security%20visual%2C%20editorial%20product%20photography%2C%20cream%20and%20sage%20green%20aesthetic%2C%20clean%20confident%20composition&width=600&height=400&seq=blog-safe-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-best-products',
    title: 'Best Products Found Using ACBuy Spreadsheet This Month',
    excerpt: 'A curated roundup of standout products discovered through the acbuy spreadsheet system across categories, with pricing insights and trend analysis.',
    tag: 'Product Roundup',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=Curated%20product%20collection%20flatlay%20with%20small%20accessories%20and%20textiles%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20organized%20aesthetic%2C%20thoughtful%20arrangement&width=600&height=400&seq=blog-bestprod-v2&orientation=landscape',
  },
  {
    path: '/acbuy-spreadsheet-save-money',
    title: 'How to Save Money Using ACBuy Spreadsheet Effectively',
    excerpt: 'Practical strategies and proven techniques for maximizing savings with the acbuy spreadsheet. Time purchases, spot value, and avoid overpaying.',
    tag: 'Money-Saving Guide',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Piggy%20bank%20and%20coins%20concept%20with%20warm%20minimal%20styling%20on%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20savings%20photography%2C%20elegant%20warm%20aesthetic%2C%20clean%20sophisticated%20composition&width=600&height=400&seq=blog-savemoney-v2&orientation=landscape',
  },
];

export default function ArticleGrid() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-14">
          <p className="text-xs font-semibold tracking-widest text-accent-600 uppercase mb-4">
            SEO Guides &amp; Resources
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            Master the <span className="text-primary-600">ACBuy Spreadsheet</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-4 max-w-xl leading-relaxed">
            Explore our library of in-depth guides covering everything from beginner walkthroughs to advanced money-saving strategies.
          </p>
        </div>

        {/* Article Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              {/* Card Image */}
              <div className="relative h-48 overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block text-[10px] font-semibold tracking-wider text-primary-700 uppercase bg-background-50/90 backdrop-blur-sm px-2.5 py-1 rounded-full">
                    {article.tag}
                  </span>
                </div>
              </div>

              {/* Card Content */}
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-background-200">
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap">
                    Read Article
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}